import React from 'react';

import UploadRosters from '../components/UploadRosters';

const UploadRostersAppClient = (props) => (
  <UploadRosters {...props} />
);

export default UploadRostersAppClient
